


























































import { Component, Vue, Watch } from 'vue-property-decorator'
// import TheSectionNavi from './component/TheSectionNavi.vue'

import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import { isNull, isUndefined } from 'lodash'
import { debounce } from 'lodash/fp'
import LoadingScreen from '@/components/LoadingScreen.vue'
import TheCompletionCheckModal from '@core/components/TheCompletionCheckModal.vue'
import KYCFormValidation from '@/validation/KYCFormValidation'
import API from '@core/services/API'
import { Route } from 'vue-router'
import { FormOptions } from '@master/model/kyc-form/FormOptions'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import { IProjectSettings } from '@master/config/IProjectSettings'
import AppCloneForm from '@core/components/AppCloneForm.vue'
import { UIService } from '@core/services/UIService'
import { IDateService } from '@master/services/IDateService'
import { IRiskRatingService } from '@master/services/IRiskRatingService'
import { CloneSectionMapping } from './model/CloneSectionMapping'

const TheSectionNavi = () => import('./component/TheSectionNavi.vue')

const kycFormStore = namespace('KYCFormStore')
const kycSubmissionStore = namespace('KYCSubmissionStore')
const kycSectionStore = namespace('KYCSectionStore')

@Component({
  components: {
    TheSectionNavi,
    LoadingScreen,
    TheCompletionCheckModal,
    AppCloneForm
  },
  beforeRouteUpdate (to: Route, from: Route, next: any) {
    this.save()
    next()
  }
})
export default class TheKYCForm extends Vue {
  @inject()
  private sharedVariable: SharedVariable

  @kycFormStore.State
  loadingState!: 'loading' | 'loaded'

  @kycFormStore.State
  private kycForm!: KYCForm

  @kycFormStore.State
  private formOptions!: FormOptions

  @kycFormStore.Mutation
  public setLoadingState!: (state: string) => void

  @kycFormStore.State
  private kycFormErrors: {}

  @kycFormStore.State
  private computedValidationResult: {}

  @kycFormStore.Action
  public loadKYCForm!: (formOid: string) => void

  @kycFormStore.Action
  public loadAssumption!: () => void

  @kycFormStore.Action
  public updatedValidationResult!: (result) => void

  @kycFormStore.Action
  public updateShowCompletionModalState!: (state) => void

  @kycSectionStore.State
  private totalUploadedPdf: []

  @kycSectionStore.Mutation
  private updateTotalUploadedPdf: (list: []) => void

  @kycSectionStore.Mutation
  private hideSection: (name: string) => void

  @kycSubmissionStore.Getter
  isSuperiorVerified

  @kycSubmissionStore.Getter
  isPTCVerified

  @kycSubmissionStore.Getter
  kycPdf

  @kycSubmissionStore.Getter
  getPTCChecklist

  @inject()
  private $api: API

  uiService: UIService

  @inject()
  private projectSettings: IProjectSettings

  @inject()
  private dateService: IDateService

  @inject()
  private riskRatingService: IRiskRatingService

  private isModalCloneVisible = false

  get isSubmissionPage () {
    return this.$route.name === 'KYC Confirmation'
  }

  get kycFormOid () {
    return this.$route.params.formOid
  }

  private snakeCaseKycForm = {}

  private cloneAppMapping = CloneSectionMapping

  debounceValidate = debounce(500, this.validate)

  // Vue lifecycles

  async created () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
    await this.checkKycDocUploadEnabled()
    await this.loadAssumption()
    await this.loadKYCForm(this.$route.params.formOid)
    if (!isNull(this.kycFormErrors) && !isUndefined(this.kycFormErrors)) {
      window.alert(this.kycFormErrors)
    }
  }

  async checkKycDocUploadEnabled () {
    /* eslint-disable @typescript-eslint/camelcase */
    const { kyc_doc_upload } = await this.sharedVariable.sysInfo
    console.log(kyc_doc_upload)

    if (!kyc_doc_upload) {
      this.hideSection('appendix')
    } else {
      const uploadedPDFList = await this.$api.uploadDoc.list({ kycFormOid: this.kycFormOid })
      this.updateTotalUploadedPdf(uploadedPDFList)
    }
    /* eslint-enable */
  }

  // Methods
  async save () {
    const rawKycForm = this.kycForm.convertToRawData()
    rawKycForm._oid = this.$route.params.formOid
    // Not saving it yet until all has been confirmed to be equal/similar
    this.setLoadingState('saving')
    // including the calculations
    await this.$api.kycForm.meta({
      _oid: this.$route.params.formOid,
      meta: JSON.parse(JSON.stringify(rawKycForm))
    }).then((response) => {
      console.log(response)
      return response
    }).finally(() => {
      this.setLoadingState('loaded')
    })
  }

  async submit () {
    if (!this.isPTCVerified) {
      window.alert('You must verify all PTC fields before you can confirm this submission.')
    } else if (!this.isSuperiorVerified) {
      window.alert('You must select a supervisor to submit to before you can confirm this submission.')
    } else if (this.kycForm.recommendations.rcmd.length === 0) {
      window.alert('No product selected, unable to proceed.')
    } else if (this.appendixIsMorethan10MB()) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Total size of appendix cannot more than 10MB'
      })
    } else {
      console.time('submission')
      // Run the validation again
      // this.validate()
      this.kycPdf.completion = JSON.parse(JSON.stringify(this.computedValidationResult))

      if (!this.KYCFormCompletionCheck()) {
        return
      }

      if (this.kycForm.recommendations.hasNtuc) {
        const dsfVerified = await this.verifyDsfFields()
        if (!dsfVerified) return
      }

      // Check for recommended products risk rating, if its higher than client's risk profile rating
      // @TODO: Not tested, wait till recommendation is completed
      // if(!this.productRiskRatingGreaterThanRPACheck()){
      //   return;
      // }

      // Perform a save before submission
      await this.save()
      this.setLoadingState('saving')
      // Get the form to be submitted
      this.kycPdf.kycFormOid = this.$route.params.formOid
      const data = this.kycPdf.prepareForSubmission()

      // Call for creation of kyc pdf
      const kycResult = await this.createKycPdfEntry(data)

      // Only when it succeed, then call for the rest of the endpoints
      if (kycResult.success) {
        const kycPdfOid = kycResult._oid
        const esubResult = await this.saveNewESubmissionData(kycPdfOid)
        const adviserResult = this.stampAdviserSignedPdf(kycPdfOid)
        if (!adviserResult) {
          window.alert('An error occured while generating the pdf for this case')
        }
        const amlResult = this.stampAdviserSignedAMLPdf(kycPdfOid)
        if (!amlResult) {
          window.alert('An error occured while generating the aml pdf for this case')
        }
        const boResult = await this.stampBeneficialOwnersPdf(kycPdfOid)
        if (!boResult) {
          window.alert('An error occured while generating the beneficial owners pdf for this case.')
          return
        }
        const pepResult = await this.stampPEPPdfs(kycPdfOid)
        if (!pepResult) {
          window.alert('An error occured while generating the pep pdfs for this case')
        }
        // JPara's specific, AML will sort of take the place
        // const ecddResult = await this.stampECDDPdfs(kycPdfOid)
        // if (!ecddResult) {
        //   window.alert('An error occured while generating the ecdd pdfs for this case')
        // }
        // merge appendix
        const mergedResult = await this.mergeUploadedAppendix(kycPdfOid)
        if (!mergedResult) {
          await this.uiService.alert.show({
            type: 'error',
            message: 'An error occured while merging appendix to client pdf for this case'
          })
        }

        // Redirect to the kyc pdf
        window.location.href = '/live/kyc-pdf/' + kycPdfOid
      } else {
        window.alert('An error occured while submitting this form with message: ' + kycResult.error)
      }
      this.setLoadingState('loaded')
      console.timeEnd('submission')
    }
  }

  async verifyDsfFields () {
    const ntucisEnabled = this.sharedVariable?.sysInfo?.esub_ntuc
    if (!ntucisEnabled) return true // if ntuc is disabled , no need do verification

    const res = await this.$api.dsf.verifyFields({
      kycFormOid: this.$route.params.formOid
    })
    if (res && res.error) {
      alert(res.error)
      return false
    } else return true
  }

  async previewPDF () {
    // should trigger a save first before opening preview
    await this.save()
    // eslint-disable-next-line @typescript-eslint/camelcase
    const useEjsTemplate = this.projectSettings?.useDynamicPdf?.enable ?? false

    // eslint-disable-next-line @typescript-eslint/camelcase
    if (useEjsTemplate) { // if the flag is on use the latest api where generate pdf preview using ejs template
      const apiVersion = this.projectSettings.useDynamicPdf.apiVersion
      const version = apiVersion === 'v1' || !apiVersion ? '' : `/${this.projectSettings.useDynamicPdf.apiVersion}`
      window.open(`/live/api${version}/kycPdf/preview/${this.kycFormOid}`, '_blank')
      // window.open(`/live/api/kycPdf/ecdd?_oid=${this.kycFormOid}&index=0`, '_blank')
    } else {
      window.open('/live/pdf/stampedpreviewpdf?_oid=' + this.kycFormOid, '_blank')
    }
  }

  appendixIsMorethan10MB () {
    const list = this.totalUploadedPdf
    if (!list.length) return false
    const totalSize = list.map(({ fileSize }) => fileSize)
      .reduce((sum, size) => {
        const total = sum + size
        return total
      }, 0)
    return totalSize > 10000000
  }

  validate () {
    console.time('Validation')
    const validation = new KYCFormValidation(this.kycForm, this.getPTCChecklist)
    this.updatedValidationResult(validation.validate())
    console.timeEnd('Validation')
  }

  // Submission methods

  createKycPdfEntry (kycPdfSubmission) {
    return this.$api.kycPdf.create(kycPdfSubmission)
      .then((res) => {
        console.log('api.createKycPdfEntry.POST res', res)
        return res
      }).catch((err) => {
        console.log('api.createKycPdfEntry.POST err', err)
        return { error: err }
      })
  }

  async stampAdviserSignedPdf (kycPdfOid) {
    const useEjsTemplate = this.projectSettings?.useDynamicPdf?.enable ?? false
    const stampedPdf = useEjsTemplate
      ? () => this.$api.kycPdf.generateKycPdfNest({ _oid: kycPdfOid })
      : () => this.$api.kycPdf.stampedKycPdf({
        _oid: kycPdfOid,
        status: 'adviser-confirmed'
      })

    return await stampedPdf().then((res) => {
      return res.success ?? true
    }).catch((err) => {
      console.error(err)
      return false
    })
  }

  stampAdviserSignedAMLPdf (kycPdfOid) {
    return this.$api.kycPdf.stampedAMLPdf({
      _oid: kycPdfOid,
      status: 'adviser-confirmed'
    })
      .then((res) => { return res.success })
      .catch((err) => {
        console.log(err)
        return false
      })
  }

  stampBeneficialOwnersPdf (kycPdfOid) {
    return this.$api.kycPdf.stampedBeneficialOwnerPdf({ _oid: kycPdfOid })
      .then((res) => { return res.success })
      .catch((err) => {
        console.log(err)
        return false
      })
  }

  stampPEPPdfs (kycPdfOid) {
    return this.$api.kycPdf.stampPEPPdf({ _oid: kycPdfOid })
      .then((res) => { return res.success })
      .catch((err) => {
        console.log(err)
        return false
      })
  }
  // JPara's specific
  // stampECDDPdfs (kycPdfOid) {
  //   return this.$api.kycPdf.stampECDDPdf({ _oid: kycPdfOid })
  //     .then((res) => { return res.success })
  //     .catch((err) => {
  //       console.log(err)
  //       return false
  //     })
  // }

  async mergeUploadedAppendix (kycPdfOid) {
    const params = {
      kycFormOid: this.kycFormOid,
      kycPdfOid: kycPdfOid
    }
    return await this.$api.uploadDoc.merge(params)
  }

  saveNewESubmissionData (kycPdfOid) {
    return this.$api.esub.create({ kycPdfOid: kycPdfOid })
      .then((esubRes) => {
        console.log('esubRes', esubRes)
        return this.$api.kycPdf.updateConsolidateGroupsStatus({ kycPdfOid: kycPdfOid })
          .then((res) => {
            console.log('updateConsolidatedGroupsStatus res', res)
            return res
          })
      })
  }

  KYCFormCompletionCheck () {
    const boDecl = this.kycForm.client1.beneficialOwner.declarationBeneficialOwner
    const bo2Decl = this.kycForm.client2.beneficialOwner.declarationBeneficialOwner
    const isClient2Included = this.kycForm.client2.personalDetails.included
    const pepDeclClient0 = this.kycForm.clientDeclaration.client0DeclarationPoliticallyExposed
    const pepDeclClient1 = this.kycForm.clientDeclaration.client1DeclarationPoliticallyExposed

    if ((boDecl === null || boDecl === undefined || boDecl === '') || (isClient2Included && (bo2Decl === null || bo2Decl === undefined || bo2Decl === ''))) {
      window.alert('You must complete the BOP section under Client Declaration before proceeding.')
      return false
    }

    if ((pepDeclClient0 === null || pepDeclClient0 === undefined || pepDeclClient0 === '') || (isClient2Included && (pepDeclClient1 === null || pepDeclClient1 === undefined || pepDeclClient1 === ''))) {
      window.alert('You must complete the PEP section under Client Declaration before proceeding.')
      return false
    }

    const boResult = this.computedValidationResult['Beneficial Owner Particulars Form']

    if ((boDecl === 'no' || bo2Decl === 'no') && boResult) {
      window.alert('You must complete the Beneficial Owner Particulars Form before you can confirm this submission.')
      return false
    }

    const pepResult = this.computedValidationResult['Politically Exposed Person Form']
    if (pepResult) { // clientdeclarationvalidation will take care of declaration flag check
      window.alert('You must complete the Policitally Exposed Person Form before you can confirm this submission.')
      return false
    }

    const amlValidation = this.computedValidationResult['Client\'s AML Check']
    if (amlValidation) {
      window.alert('You must complete the AML Form before you can confirm this submission.')
      return false
    }

    return true
  }

  async deleteForm () {
    if (!this.doesKycPdfExist()) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'You may only delete a KYC Form that has not had a KYC PDF generated.'
      })
      return false
    }

    const isConfirm = await this.uiService.confirm.show({
      type: 'warning',
      message: 'Are you sure you want to permanently delete this KYCForm?'
    })
    if (isConfirm) {
      const resp = await this.$api.kycForm.delete({ _oid: this.$route.params.formOid })
      await this.uiService.confirm.show({
        type: 'success',
        message: 'KYCForm has been deleted',
        showCancelButton: false
      })
      window.location.href = '/live/home-adviser'
    }
  }

  async doesKycPdfExist () {
    const response = await this.$api.kycPdf.list({
      query: 'kyc_id = ?',
      queryArgs: JSON.stringify([this.$route.params.formOid]),
      headers: JSON.stringify([
        '_oid',
        'pdf_status'
      ])
    })
    return response.data.length > 0
  }

  // productRiskRatingGreaterThanRPACheck () {
  //   let result = true

  //   const rcmdObjs = this.kycForm.recommendations.rcmd || []
  //   if (rcmdObjs.length > 0) {
  //     for (let i = 0; i < rcmdObjs.length; ++i) {
  //       const clientChoice = rcmdObjs[i].clientChoice
  //       const typeOfProduct = rcmdObjs[i].typeOfProduct // either 'insurance' or 'investment'
  //       const productListType = rcmdObjs[i].productType || '' // 'product type' value from the product library
  //       const productListCategory = rcmdObjs[i].category || '' // 'category' value from the product library

  //       const rcmdRiskRating = rcmdObjs[i].recommendedRiskProfile
  //       const clientIndex = rcmdObjs[i].clientIndex
  //       const clientCka = clientIndex === 0 ? this.kycForm.client1.cka : this.kycForm.client2.cka

  //       const clientRpa = clientIndex === 0 ? this.kycForm.client1.rpa : this.kycForm.client2.rpa
  //       let clientRiskProfile = clientRpa.riskProfile
  //       if (clientRpa.riskProfile === 'as_per_questionnaire') {
  //         if (clientRpa.agreement === 'no') {
  //           clientRiskProfile = clientRpa.riskProfilePreferred
  //         } else {
  //           clientRiskProfile = clientRpa.riskProfileCalculated
  //         }
  //       }

  //       const clientPassedCKA = (clientCka.ckaMet || 'yes') === 'yes'

  //       // if product is of type investment
  //       if (typeOfProduct === 'investment') {
  //         if (clientChoice === 'ownchoice') {
  //           // if product risk rating is greater than client rpa result
  //           if (this.isRcmdRiskRatingGreaterThanClientRPA(rcmdRiskRating, clientRiskProfile)) {
  //             if (!clientPassedCKA) {
  //               result = false
  //               window.alert('Unable to submit KYC as a non-recommended investment product has a higher risk rating than Client ' + (clientIndex + 1) + '\'s risk profile rating, and Client failed CKA.')
  //             }
  //           }
  //         }
  //       } else if ((productListType.toLowerCase().indexOf('ilp') !== -1 || productListCategory.toLowerCase().indexOf('investment-linked') !== -1)) { // if product is an ILP
  //         if (clientChoice === 'accept' || clientChoice === 'ownchoice') {
  //           if (this.isRcmdRiskRatingGreaterThanClientRPA(rcmdRiskRating, clientRiskProfile)) {
  //             result = false
  //             window.alert('Unable to submit KYC as an ILP product has a higher risk rating than Client ' + (clientIndex + 1) + '\'s risk profile rating.')
  //           }
  //         }
  //       }
  //     }
  //   }
  //   return result
  // }

  // isRcmdRiskRatingGreaterThanClientRPA (rcmdRiskRating, clientRiskProfile) {
  //   // if client risk profile result is null, always return true
  //   if (clientRiskProfile === undefined || clientRiskProfile === null) {
  //     return true
  //   }

  //   let enumClientRiskProfile = 0
  //   switch (clientRiskProfile) {
  //     case 'conservative':
  //       enumClientRiskProfile = 1
  //       break
  //     case 'moderately_conservative':
  //       enumClientRiskProfile = 2
  //       break
  //     case 'balanced':
  //       enumClientRiskProfile = 3
  //       break
  //     case 'moderately_aggressive':
  //       enumClientRiskProfile = 4
  //       break
  //     case 'aggressive':
  //       enumClientRiskProfile = 5
  //       break
  //     default:
  //       enumClientRiskProfile = 0
  //   }

  //   if (rcmdRiskRating > enumClientRiskProfile) {
  //     return true
  //   }

  //   return false
  // }

  // Watchers
  @Watch('kycForm', { deep: true })
  kycFormChanged () {
    this.debounceValidate()
  }
}
